import React from 'react';

const Planet = (props) => {
	return (
		<div className="planet-group">
			<div id="earth" className="earth"></div>
			<div id="mars" className="mars"></div>
			<div id="moon" className="moon">
				<div className="crater"></div>
				<div className="crater-2"></div>
				<div className="crater-3"></div>
			</div>
		</div>
	)
}

export default Planet;